<template>
<div>

     <v-app-bar id="home-app-bar" v-if="bar && !isLoading" class=" home-app-bar px-12" dark app :color="(settings[0] ? settings[0].color : '#2F839D')" height="44">
       <span class="enTet   hidden-sm-and-down"> {{ $t('retrovResultSur')  + " : " }} </span> <a href="http://frontend.mesanalyses.dz/" class="enTet mx-2">Mesanalyses  </a> 
          <a href="#"  class="enTet ma-8   hidden-sm-and-down">{{ settings[0]  ? settings[0].webname : "" }}</a>
          <v-spacer />
          <v-menu transition="fab-transition" offset-y>
               <template v-slot:activator="{ on }">
                    <v-toolbar-items>
                         <v-btn text v-on="on">
                              <v-icon class="mx-2">mdi-translate</v-icon>
                              <span class=" hidden-sm-and-down">{{ nameLang }}</span>
                         </v-btn>
                    </v-toolbar-items>
               </template>
               <v-list>
                    <v-list-item v-for="(item, index) in langs" :key="index" @click="changLang(item.id)">
                         <v-list-item-icon style="margin-right: 5px;">
                              <!-- <flag :iso="item.flag" /> -->
                         </v-list-item-icon>
                         <v-list-item-content  style="margin-right: 5px;">{{ item.name }}</v-list-item-content>
                    </v-list-item>
               </v-list>
          </v-menu>
     </v-app-bar>

    <v-skeleton-loader v-else ref="skeleton" type="table-heading"></v-skeleton-loader>

</div>
</template>

<script>
export default {
     data() {
          return {
               bar: true, 
               flag: "",
               lang: "fr",
               langs: [{
                         id: "ar",
                         name: "العربية",
                         flag: "dz"
                    },
                    {
                         id: "fr",
                         name: "Français",
                         flag: ""
                    },

               ],
          }
     },
     methods: {
          changLang(e) {
               localStorage.setItem('lang', e)
               Fire.$emit('ChangeLang', e);
               // axios.post("/api/changLang", {
               //      lang: e
               // });  
               this.lang = e;
          },
          handleScroll(event) {
               var doc =  document.getElementById("home-app-bar")
               if ((event.path[1].pageYOffset > 70) && doc) {
                    doc.style.top = "-110px"
                    doc.style.transition = "0.2s"
               } else {
                    doc.style.top = "0px"
                    doc.style.transition = "0.5s"
               }
          }
     },
     computed: {
          nameLang() {
               return this.langs.find(e => e.id == this.lang)["name"];
          },
          // flagLang() {
          //      if (this.lang == "ar") {
          //           return "dz";
          //      } else {
          //           return "";
          //      }
          // },
     },
     created() {
          window.addEventListener('scroll', this.handleScroll);
          this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : localStorage.setItem('lang', 'fr')
     },
     destroyed() {
          window.removeEventListener('scroll', this.handleScroll);
     },
}
</script>

<style >

</style>
